import React from 'react';
import './Header.scss';
import { Icon } from 'antd';

interface IProps {
  onBack?: () => void;
  onClose: () => void;
}

const Header: React.SFC<IProps> = ({ onBack, onClose }) => (
  <div className='header'>
    { onBack && 
      <div className='back-button' onClick={ onBack }>
        <Icon type='arrow-left' />
      </div>
    }
    <div className='close-button' onClick={ onClose }>
      <Icon type='close' />
    </div>
  </div>
);

export default Header;


// WEBPACK FOOTER //
// ./src/components/MenuUser/Header/Header.tsx